import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import './InfoModal.scss';
import { modalText } from './textForInfoModal';
import { hmTableInfo } from '../../Utilities/Helpers';

export default function InfoModal({ infoModal, handleOptionsChange }) {
  const [open, setOpen] = useState(true);
  const [content, setContent] = useState(<div id='info-modal'></div>);
  const modalContent = modalText((e, choice) => {
    e.preventDefault();
    handleOptionsChange(choice, 'infoModal');
  });

  const handleClose = () => {
    setOpen(false);
    handleOptionsChange(null, 'infoModal');
  };

  const buildHMTable = () => {
    const rows = hmTableInfo();

    return (
      <Table size='small' id='hm-table'>
        <TableHead>
          <TableRow className='hm-table-head'>
            {rows.shift().map((head) => (
              <TableCell key={head}>{head}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => {
            return (
              <TableRow key={i}>
                <TableCell>{row[0]}</TableCell>
                <TableCell>
                  <ul className='hm-table-list'>
                    {row[1].map((hazard) => (
                      <li key={hazard}>{hazard}</li>
                    ))}
                  </ul>
                </TableCell>
                <TableCell>
                  <ul className='hm-table-list'>
                    {row[2].map((clim) => (
                      <li key={clim}>{clim}</li>
                    ))}
                  </ul>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  };

  useEffect(() => {
    // Retrieve desired text from the files imported above
    let textObj = modalContent[infoModal];
    let lists = textObj.lists.map((listObj, index) => {
      if ('heading' in listObj) {
        return (
          <React.Fragment key={index}>
            <div className='list-title'>{listObj.heading}</div>
            <ul>
              {listObj.items.map((item, index) =>
                item === 'hmTable' ? (
                  buildHMTable()
                ) : (
                  <li key={index}>{item}</li>
                )
              )}
            </ul>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment key={index}>
            {listObj.items.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </React.Fragment>
        );
      }
    });

    setContent(
      <div id='info-modal'>
        <div className='close-modal'>
          <CloseIcon onClick={handleClose} />
        </div>

        <h2 id='custom-modal-title'>{textObj.title}</h2>
        <div id='custom-modal-description'>{lists}</div>
      </div>
    );
  }, [infoModal]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='custom-modal-title'
      aria-describedby='custom-modal-description'
    >
      {content}
    </Modal>
  );
}

InfoModal.propTypes = {
  infoModal: PropTypes.string,
  handleOptionsChange: PropTypes.func,
};
